export const tokenDecoder = (token: string) => {
  try {
    // JWT gövdesi base64url ve UTF 8 kodludur; atob yalnızca standart
    // base64 okur.
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '='));
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
};
